<template>
    <AppSeoTags>
        <title>TyreSeeker Awards</title>
        <link head-key="canonical" rel="canonical" :href="currentUrl">
    </AppSeoTags>
    <AppJumbotron class="relative" :without-tyres="true">
        <h1 class="text-3xl lg:text-4xl xl:text-5xl tracking-wide text-white max-w-[500px]">Tyre Seeker Awards</h1>
        <p class="text-white mt-4 max-w-[550px] mb-16">Former motor racing driver and journalist Steve Sutcliffe has worked with Tyre Seeker to review and identify the very best tyres of 2022. We tested the tyres in a number of different conditions to bring you a definitive list of impartial tyre reviews highlighting what we believe to be the stand-out tyres of the past 12 months.</p>
        <div class="absolute bottom-4 left-1/2 transform hidden lg:block">
            <img src="/images/awards-header.png" alt="Tyre Seeker Awards" />
        </div>
    </AppJumbotron>
    <AppContainer class="pt-4 pb-8">
        <div class="flex items-center justify-center">
            <div class="border-2 w-full md:w-4/5 px-8 py-2 border-primary rounded-lg md:rounded-full">
                <form @submit.prevent="form.get('awards')">
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div class="flex self-center">
                            <strong class="text-center md:text-left">Filter Awards</strong>
                        </div>
                        <div>
                            <label class="block xl:inline-block pr-4">Year</label>
                            <select @change="submitForm()" v-model="form.year" class="w-full md:w-full lg:w-3/4">
                                <option v-for="(year, index) in years">{{ year }}</option>
                            </select>
                        </div>
                        <div>
                            <label class="block xl:inline-block pr-4">Season</label>
                            <select @change="submitForm()" v-model="form.season" class="w-full md:w-full lg:w-3/5">
                                <option v-for="(season, index) in seasons">{{ season }}</option>
                            </select>
                        </div>
                        <div>
                            <label class="block xl:inline-block pr-4">Application</label>
                            <select @change="submitForm()" v-model="form.application" class="w-full md:w-full lg:w-1/2">
                                <option v-for="(application, index) in applications">{{ application.classification }}</option>
                            </select>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </AppContainer>
    <AppContainer>
        <div v-if="groups.length">
            <div v-for="(group, index) in groups">
                <AwardGroup :group="group"></AwardGroup>
            </div>
        </div>
        <div v-else>
            <div class="bg-red p-6 text-white text-center">
                <p>No awards found</p>
            </div>
        </div>
    </AppContainer>
</template>

<script>
import AppContainer from "@/Layouts/AppContainer";
import AppSeoTags from "@/Components/AppSeoTags";
import AppJumbotron from "@/Components/AppJumbotron";
import AwardGroup from "@/Components/Awards/AwardGroup";
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    name: "ViewAllReviews",
    components: {
        AwardGroup,
        AppContainer,
        AppSeoTags,
        AppJumbotron,
        useForm
    },
    props:
    {
        groups: Object,
        seasons: Object,
        years: Object,
        applications: Object,
        chosenYear: String,
        chosenSeason: String,
        chosenApplication: String
    },
    data()
    {
        return {
            form: useForm({
                year: this.chosenYear,
                season: this.chosenSeason,
                application: this.chosenApplication
            })
        }
    },
    methods: {
        submitForm()
        {
            this.form.post(route('awards'), {
                preserveScroll: true,
                onSuccess: (response) =>
                {

                }
            });
        }
    }
}
</script>

<style scoped>

</style>
